import { Scan, Space } from "types/generated";
import { ScanProviderConfigItem, ScanScopeItem } from "views/Account/Scans/types";

export enum ScanDetailsDrawerTab {
  ScanDetails = "SCAN_DETAILS",
  AttachProviders = "ATTACH_PROVIDERS",
  Scope = "SCOPE",
}

export type ScanDetailsDrawerItem = Pick<
  Scan,
  | "id"
  | "name"
  | "description"
  | "labels"
  | "workerPool"
  | "workerPoolName"
  | "createdAt"
  | "updatedAt"
> & {
  space: Pick<Space, "id" | "name">;
  providerConfigs: Array<ScanProviderConfigItem>;
  scope: Array<ScanScopeItem>;
  latestRun: Pick<NonNullable<Scan["latestRun"]>, "stateChangedAt"> | null;
};
